import { SWStoreImpl } from "@supersig/store";
import { createSWSchema } from "./createSWSchema";
/**
 * A helper for creating a SWStore. Custom shapes cannot override default shapes.
 *
 * @param opts - Options for creating the store.
 *
 * @public */ export function createSWStoreWithShapeNodeMap({ initialData, defaultName = "", ...rest }) {
    const schema = "schema" in rest && rest.schema ? rest.schema : createSWSchema({
        nodes: "nodeTypeMap" in rest && rest.nodeTypeMap ? rest.nodeTypeMap : {},
        loadables: "loadableTypeMap" in rest && rest.loadableTypeMap ? rest.loadableTypeMap : {}
    });
    return new SWStoreImpl({
        schema,
        initialData,
        props: {
            defaultName
        }
    });
}
